import SearchTag from '@/common/search-tag-list';
import { acreToSqft } from '@/common/utils';
import { mobileOutFields } from '@/modules/md-search/_conf/index';
// TODO delete
export let searchCenter = { searchCenter: false };

function getSuggestionValue(valueArr) {
    return valueArr.reduce((memo, val) => {
        const [type, value] = val.split(':');
        memo[type] || (memo[type] = []);
        memo[type].push(value);
        return memo;
    }, {});
}

const processApiParams = {
    mapPath(searchData, mapCondition) {
        if (mapCondition.mapPath) {
            searchData['location'] = {
                mapPath: JSON.parse(mapCondition.mapPath).map(o =>
                    JSON.stringify(o)
                )
            };
        }
        return searchData;
    },
    keywords(searchData, state) {
        if (state.keywords.length) {
            const obj = state.keywords.reduce((acc, cur) => {
                acc[cur.keywordType] || (acc[cur.keywordType] = []);
                acc[cur.keywordType].push(cur.keyword);
                return acc;
            }, {});
            searchData['location'] = obj;
        }
        return searchData;
    },
    conditionArr(searchData, state) {
        const conditions = state.conditions;
        Object.entries(conditions).forEach(([name, o]) => {
            let { value, inputType } = o;
            if (name === 'location') return;
            if (inputType === 'suggestion') {
                value = getSuggestionValue(value);
            }

            const ui = state.uiConfig[name];
            const { sqft } = ui || {};
            if (sqft === 'acre' && value) {
                const [v1, v2] = value.split(',');
                value = `${acreToSqft(v1)},${acreToSqft(v2)}`;
            }
            searchData[name] = value;
        });
        return searchData;
    }
};

function handleParams(params, state, rootState) {
    const isSearchCenter = rootState.common.isSearchCenter;
    if (isSearchCenter) {
        let searchData = {};
        const mapCondition = JSON.parse(JSON.stringify(state.mapCondition));
        if (state.keywords.length > 0) {
            searchData = processApiParams.keywords(searchData, state);
        } else {
            searchData = processApiParams.mapPath(searchData, mapCondition);
        }
        delete mapCondition.mapPath;
        searchData = processApiParams.conditionArr(searchData, state);
        params.condition = JSON.stringify(searchData);
        params.uiConfig = JSON.stringify(state.uiConfig || {});
        Object.assign(params, mapCondition);
    } else {
        Object.assign(params, state.mapCondition);
        if (state.keywords.length) {
            const SPLIT = ';';
            params.key = state.keywords.map(obj => obj.keyword).join(SPLIT);
            params.keywordType = state.keywords
                .map(obj => obj.keywordType)
                .join(SPLIT);
        }
        state.conditionsArr.forEach(kee => {
            let value = state.conditions[kee].value;
            if (!value) {
                return;
            }
            params[kee] = state.conditions[kee].value;
        });
    }
    return params;
}

function adaptSearchParams(params, state, rootState) {
    const isSearchCenter = rootState.common.isSearchCenter;
    if (isSearchCenter) {
        let searchData = {};
        const mapCondition = state.mapCondition;
        if (state.keywords.length > 0) {
            searchData = processApiParams.keywords(searchData, state);
        } else {
            searchData = processApiParams.mapPath(searchData, mapCondition);
        }
        searchData = processApiParams.conditionArr(searchData, state);
        params.condition = JSON.stringify(searchData);
        params.uiConfig = JSON.stringify(state.uiConfig || {});
    } else {
        if (state.keywords.length) {
            const SPLIT = ';';
            params.key = state.keywords
                .map(obj => obj.keywordType + ':' + obj.keyword)
                .join(SPLIT);
        }
        state.conditionsArr.forEach(kee => {
            let value = state.conditions[kee].value;
            if (!value) {
                return;
            }
            params[kee] = state.conditions[kee].value;
        });
    }
    return params;
}

// process input type suggestion
function adaptAllConditions(allConditions, state, rootState) {
    // this -> $store
    const isSearchCenter = rootState.common.isSearchCenter;
    let conditions = state.conditions;
    if (isSearchCenter) {
        Object.entries(conditions).forEach(([name, o]) => {
            let values;
            if (o.inputType === 'suggestion') {
                values = getSuggestionValue(o.value);
            } else {
                values = o.value;
            }
            allConditions.push({
                dn: name,
                values
            });
        });
        return allConditions;
    } else {
        state.conditionsArr.forEach(key => {
            let item = conditions[key];
            if (!item.value) {
                return;
            }
            allConditions.push({
                dn: item.kee,
                values:
                    typeof item.value === 'string'
                        ? item.value.split(item.split || ',')
                        : [item.value],
                labels: item.labels
            });
        });
        return allConditions;
    }
}

// const adaptConditions = (state, payload) => {
//     const isSearchCenter = searchCenter.searchCenter;
//     let conditions = util.cloneData(state.conditions);
//     let conditionsArr = util.cloneData(state.conditionsArr);
//     let item = conditions[payload.kee];
//     let flag = false;
//     if (isSearchCenter) {
//         if (!item) {
//             conditionsArr.push(payload.kee);
//             state.conditionsArr = conditionsArr;
//             conditions[payload.kee] = payload;
//             flag = true;
//         } else if (
//             JSON.stringify(item.value) !== JSON.stringify(payload.value)
//         ) {
//             flag = true;
//             item.labels = payload.labels;
//             item.value = payload.value;
//             item.extra = payload.extra;
//         }
//     } else {
//         if (!item) {
//             conditionsArr.push(payload.kee);
//             state.conditionsArr = conditionsArr;
//             conditions[payload.kee] = payload;
//             flag = true;
//         } else if (
//             JSON.stringify(item.labels) !== JSON.stringify(payload.labels) &&
//             JSON.stringify(item.value) !== JSON.stringify(payload.value)
//         ) {
//             flag = true;
//             item.labels = payload.labels;
//             item.value = payload.value;
//         }
//     }
//     if (
//         flag &&
//         JSON.stringify(conditions) !== JSON.stringify(state.conditions)
//     ) {
//         state.conditions = conditions;
//     }
// };

const deleteCondition = (params, rootState) => {
    const isSearchCenter = rootState.common.isSearchCenter;
    if (isSearchCenter) {
        if (params.condition) delete params.condition;
    }
    return params;
};
const calcTagsCount = (state, getters, exclude = [], globalData) => {
    const searchConfigMap = state.searchConfigMap;
    let allCondition = getters.allConditions;
    allCondition = allCondition.reduce((memo, cur) => {
        if (exclude.includes(cur.dn)) return memo;
        memo[cur.dn] = cur.values;
        return memo;
    }, {});
    const tag = new SearchTag(
        allCondition,
        null,
        searchConfigMap,
        globalData.currencyRate
    );
    return tag.getTagSync().length;
};

const adaptMoreLen = (state, getters, rootState) => {
    const isSearchCenter = rootState.common.isSearchCenter;
    let len = 0;
    if (isSearchCenter) {
        const exclude = [
            ...state.outsideFields,
            'location',
            'key',
            'mapPath',
            'mapSearch'
        ];
        return calcTagsCount(state, getters, exclude, rootState.page.page);
    } else {
        const conditions = state.conditions;
        Object.values(conditions).forEach(cond => {
            if (cond.inMore) {
                if (cond.type === 'tag-input') {
                    len += cond.value
                        .split(cond.split)
                        .filter(label => !!label).length;
                } else {
                    len += cond.labels.filter(label => !!label).length;
                }
            }
        });
    }
    return len;
};

const adaptFilterCount = (state, getters, rootState) => {
    const isSearchCenter = rootState.common.isSearchCenter;
    let count = state.keywords.length;
    if (state.mapCondition.mapPath) {
        count++;
    }
    if (isSearchCenter) {
        const exclude = ['location', 'key', 'mapPath', 'mapSearch'];
        count += calcTagsCount(state, getters, exclude, rootState.page.page);
    } else {
        Object.values(state.conditions).forEach(cond => {
            count += cond.labels.filter(label => !!label).length;
        });
    }
    return count;
};
const adaptMobileFilterCount = (state, getters, rootState) => {
    const isSearchCenter = rootState.common.isSearchCenter;
    let count = 0;
    if (isSearchCenter) {
        const exclude = [
            'location',
            'key',
            'mapPath',
            'mapSearch',
            ...state.outsideFields.slice(0, 3)
        ];
        count += calcTagsCount(state, getters, exclude, rootState.page.page);
    } else {
        Object.values(state.conditions).forEach(cond => {
            if (!mobileOutFields.includes(cond.kee)) {
                count += cond.labels.filter(label => !!label).length;
            }
        });
    }
    return count;
};

export {
    adaptAllConditions,
    handleParams,
    deleteCondition,
    adaptSearchParams,
    adaptMoreLen,
    adaptFilterCount,
    adaptMobileFilterCount
};
